import React from 'react';
import I18n from 'i18n-js';
import { RCCallout, RCButtonLink } from '@reverbdotcom/cadence/components';
import { WarningCircleIcon } from '@phosphor-icons/react';
import { I18N } from '@reverbdotcom/commons/src/components/translate';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';

export const PHONE_VERIFICATION_PATH = '/phone-verification';

// Sellers must enroll in MFA by this date. Before it, the banner counts down;
// on or after it, the copy shifts to an enforcement message (publishing is blocked).
export const MFA_ENROLLMENT_DEADLINE = new Date('2026-07-29T05:00:00Z');

interface Props {
  // Injectable for deterministic tests around the deadline boundary.
  now?: Date;
}

export default function MfaEnrollmentBanner({ now = new Date() }: Props) {
  const subtitleKey = now >= MFA_ENROLLMENT_DEADLINE
    ? 'discovery.mfaEnrollmentBanner.subtitleAfterDeadline'
    : 'discovery.mfaEnrollmentBanner.subtitleBeforeDeadline';

  return (
    <div className="mfa-enrollment-banner mb-2">
      <RCCallout
        themeType="utility"
        variant="urgent-ultralight"
        icon={<WarningCircleIcon />}
        title={I18n.t('discovery.mfaEnrollmentBanner.title')}
        cta={(
          <RCButtonLink
            variant="themed-outlined"
            renderLink={c => <CoreLink to={PHONE_VERIFICATION_PATH}>{c}</CoreLink>}
          >
            {I18n.t('discovery.mfaEnrollmentBanner.turnOnMfa')}
          </RCButtonLink>
        )}
      >
        <I18N
          html
          tag="p"
          text={subtitleKey}
          args={{
            linkOpen: `<a href="${PHONE_VERIFICATION_PATH}" class="text-link weight-bold">`,
            linkClose: '</a>',
          }}
        />
      </RCCallout>
    </div>
  );
}
